import { helpers } from 'vuelidate/lib/validators';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import { required } from 'vuelidate/lib/validators';

const isodate = from =>
  helpers.withParams({ type: 'isodate', from }, value => {
    if (!value) return false;
    const iso = parseISO(value);
    return isValid(iso) && iso >= parseISO(from);
  });

export default {
  familyName: { required },
  givenName: { required },
  birthDate: { required, isodate: isodate('1900-01-01') },
  gender: { required },
  addressStreet: { required },
  postalCode: { required },
  addressLocality: { required },
  canton: { required },
  law: { required },
  refundType: { required }
};
